<template>
  <div id="vtour"></div>
</template>

<script>
export default {
	data() {
		return {
			num: 1,
			count: 0
		};
	},
	mounted() {
		var baseurl = "https://hmltec.oss-cn-beijing.aliyuncs.com/jinpai/vtour/tour.xml";
		// var baseurl = "http://192.168.31.86:49386/tour.xml";
		var that = this;
		var vars = [];
		vars.startscene = this.panoindex;
		window.vtourObj = this;
		// this.$store.commit("panoramaSwitch", "0");
		embedpano({
			swf: baseurl + "tour.swf",
			vars: vars,
			xml: baseurl,
			target: "vtour",
			mobilescale: 0.5,
			html5: "auto",
			passQueryParameters: true,
			consolelog: false, // 此处是控制打印
			onready(krpanoObj) {
				window.krpanoObj = krpanoObj;
				let vtourArr = [];
				// console.log("lxg", "krpano onready");
				// krpanoObj.call('goscene_hotspot(scene_02)');
				// let sceneCount = krpanoObj.get('scene.count');
				// //添加场景更新回调
				// window.krpanoObj.call('txtadd()');
			}
		});
	},
	// destroyed() {
	//   this.$store.commit("setTimeSwitchFlag", "false");
	//   console.log("lxg", "vtour destoryed1");
	// },
	methods: {
		// this.$emit('fn')
		buildSceneData() {
			let sceneArr = krpanoObj.get("scene").getArray(); // 所有的全景数据
			// console.log("vtour打印", sceneArr);
			let groupCount = krpanoObj.get("group.count"); // 分组的长度
			let groupArr = []; // 最外层数组
			//   console.log("lxg", groupCount);
			if (groupCount == 0 || groupCount == null) {
				// 如果没有分组
				let groupitem = {}; // 创建对象
				groupitem.name = "default"; // 对象的名称
				groupArr.push(groupitem); // 将对象添加进数组
				groupArr[0].sceneArr = []; // 创建二级数组
			} else {
				// 如果有分组
				for (let index = 0; index < groupCount; index++) {
					// 遍历每一个分组
					const element = krpanoObj.get("group[" + index + "]"); // 获取当前遍历对象
					groupArr.push(element); // 将对象添加进数组
					groupArr[index].sceneArr = []; // 创建二级数组
				}
			}
			groupArr[0].sceneArr = [];
			console.log(groupArr);
			let krpanoObjLength = krpanoObj.get("group[0].subgroup.count");
			for (let index = 0; index < krpanoObjLength; index++) {
				let sceneobj = krpanoObj.get("group[0].subgroup[" + index + "]");
				sceneobj.sceneArr1 = [];
				groupArr[0].sceneArr.push(sceneobj);
			}

			for (let index = 0; index < sceneArr.length; index++) {
				// 遍历所有的全景数据
				const element = sceneArr[index]; // 将当前的数据存储起来
				let sceneobj = {}; // 创建对象
				var groupid;
				// 为 groupid 赋值，groupid 代表当前groupArr所需的索引
				if(element.name == "scene_47"){
					console.log(element);
				};
				groupid = groupCount ? parseInt(element.group1) : 0;
				if (groupid >= 0) {
					if (element.group1 == groupid) {
						sceneobj.name = element.name;
						sceneobj.title = element.title;
						sceneobj.imgurl = element.thumburl;
                        sceneobj.des = element.des;
                        sceneobj.nosoundflag = element.nosoundflag;
						if (element.name == groupArr[0].startscene) {
							groupArr[0].des = element.des;
						}
						if (element.name == groupArr[1].startscene) {
							groupArr[1].des = element.des;
						}
						if (
							groupid == 0 &&
							(parseInt(element.group2) == 0 || element.group2)
						) {
							groupArr[0].sceneArr[parseInt(element.group2)].sceneArr1.push(sceneobj);
						} else {
							if (groupid != 0) {
								groupArr[groupid].sceneArr.push(sceneobj);
							}
						}
					}
				}
			}

			for (let index = 2; index < groupCount; index++) {
				// 遍历每一个分组
				groupArr[index].des = groupArr[index].sceneArr[0].des; // 创建二级数组
			}

			// console.log('lxg', groupArr);
			// console.log('lxg', 'lxg');
			this.updateSceneData(groupArr);
		},
		updateSceneData(groupArr) {
			// this.$emit('fn')
            this.$store.commit("vtourArr", groupArr);
            console.log(",,,,,,",this.$store.state.vtourArr);
		},
		activedPano(scenename) {
			this.$store.commit("activePano", scenename);
		},
		loadVtour(vtourid) {
			console.log("lxg", "loadvtour11 = " + vtourid);
			let _schoolList = this.$store.state.wholeData[0];
			console.log("lxg", _schoolList);
			for (let index = 0; index < _schoolList.length; index++) {
				const element = _schoolList[index];
				if (element.vtour == vtourid) {
					var vtourdd = document.getElementById("vtour");
					if (vtourdd) {
						vtourdd.parentNode.removeChild(vtourdd);
					}
					this.$store.commit("setdetailsIndex", index);
					this.$router.push("/panorama");
				}
			}
		}
	},
	computed: {
		listenstage() {
			return this.$store.state.activedPanoId;
		}
	},
	watch: {
		listenstage: function(ov, nv) {}
	},
	// 父组件传递的值
	props: ["vtourId", "panoindex"]
};
</script>

<style lang="scss" >
#vtour {
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: content-box !important;
}
#vtour * {
  box-sizing: content-box !important;
}
</style>
